module.exports = __webpack_public_path__ + "img/laying-spaccamattone.c190ee8a.svg";